import { type PersonTypeBase, personTypeBaseFields } from './personTypeBase';
import { type ElectionBase, electionBaseFields } from './electionBase';

export interface PersonType extends PersonTypeBase {
  elections: ElectionBase[];
}

export const personTypeFields = `
  ${personTypeBaseFields}
  elections {
    ${electionBaseFields}
  }
`;

export interface PersonTypeInput {
  congressId: string;
  name: string;
  color: string;
  electionIds?: string[];
}

export const personTypeInputFieldNames = [
  'congressId',
  'name',
  'color',
  'electionIds',
] as const;
